import api from '@/api';

import { API_BASE_URL } from '..';

import {
  FinancialMatrixSettings,
  FinancialMatrixSettingsCreateRequest,
  FinancialMatrixSettingsUpdateRequest,
} from './MatrixFinancialSettings.types';

const CONTROLLER_URL = `${API_BASE_URL}/matrix-financial-settings`;

export async function getFinancialSettingsMatrix(): Promise<FinancialMatrixSettings> {
  const result = (await api.get(`${CONTROLLER_URL}`, {})) as unknown;

  return result as FinancialMatrixSettings;
}

export async function getCreateFinancialMatrixSettings(
  obj: FinancialMatrixSettingsCreateRequest,
) {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}

export async function getUpdateFinancialMatrixSettings(
  obj: FinancialMatrixSettingsUpdateRequest,
) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}
